import deepmerge from 'deepmerge';
import { ENVIRONMENT_GLOBAL } from '../global_env';

export const environment = deepmerge(ENVIRONMENT_GLOBAL, {
  envName: 'test',
  production: true,
  matomoSrc: 'https://matomo.meinhplus.de/statistic/js/container_EfEzdlyc_test_d8abcd35cbfd5f1a7ff6fc23.js',
  redirect: {
    host: 'https://test-oms.meinhplus.de'
  },
  auth_L1: {
    client_id: 'oms-tool',
    scope: 'phone email profile openid',
    endpoint: {
      host: 'https://test-account.meinhplus.de',
      paths: {
        prefix: '/auth/realms/hekatron-tuer-tor'
      }
    }
  },
  backend: {
    scope: 'oms',
    client_id: 'oms-webapp-aS1hG5kPl7Mn0ZxC',
    endpoint: {
      host: 'https://api.test-oms.meinhplus.de'
    },
    wsEndpoint: 'wss://api.test-oms.meinhplus.de/ws'
  },
  files: {
    paths: {
      host: 'https://test-administration.meinhplus.de' //TODO check
    }
  },
  links: {
    applications: {
      mh2: {
        host: 'https://test.meinhplus.de'
      },
      hcp: {
        host: 'https://test-dashboard.meinhplus.de'
      },
      l2: {
        host: 'https://test-administration.meinhplus.de',
        domains: '/multi-domain-mgmt'
      },
      go: {
        host: 'https://test-asdconfig.meinhplus.de/securismokegoapp/de/'
      },
      hpo: {
        host: 'https://test-operator.meinhplus.de'
      },
      b2b: {
        host: 'https://test-shop.meinhplus.de'
      },
      dongle: {
        host: 'https://test-platform.meinhplus.de/#/licenses/dongle-management'
      },
      dongle_admin: {
        host: 'https://test-permissions.meinhplus.de'
      },
      learn_world: {
        host: 'https://test-lernwelt.meinhplus.de'
      }
    }
  }
});
